module.exports = __webpack_public_path__ + "img/plataformas-ticto.7b1b0bda.svg";